export default "__VITE_ASSET__hI8xN0QS__"